import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getFlatProfilePathname } from '../../../utils/link'
import { ListItem } from '../../ListItem'

import { isNeedToShowEntityProfileFlatItemIcons } from './EntityProfileFlatItem.utils'

import * as styles from './EntityProfileFlatItem.module.css'

import FlatIcon from '../../../icons/flat.svg'

function EntityProfileFlatItem({
  className = styles.EntityProfileFlatItem,
  value,
  ...restProps
}) {
  const { handleClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  function handleClickFlat() {
    const link = getFlatProfilePathname({ availableSections, id: value })

    handleClick({
      link,
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  return (
    <ListItem
      {...restProps}
      ListIcon={FlatIcon}
      className={className}
      isNeedToShowIcons={isNeedToShowEntityProfileFlatItemIcons}
      textClassName={styles.text}
      tooltipProps={{ placement: FLOATING_ELEMENT_PLACEMENT.top }}
      onClick={handleClickFlat}
    />
  )
}

export default EntityProfileFlatItem
